module.exports = __webpack_public_path__ + "static/media/star_666666.ccdaf674.svg";